import { window } from '../window.js';

/**
 * Emulates the local storage when it's not available.
 */
class InMemoryLocalStorage {
  getItem(key) {
    return this.#data.get(key);
  }
  setItem(key, value) {
    this.#data.set(key, String(value));
  }
  removeItem(key) {
    this.#data.delete(key);
  }
  #data = new Map();
}

/**
 * Local persistent storage of JSON stringifyable data.
 */
class Storage {
  get(key) {
    let value = this.#storage.getItem(key);
    if (value == null) {
      return undefined;
    }
    try {
      return JSON.parse(value);
    } catch (e) {
      this.reportError(`Failed to parse ${key} setting of '${value}' value`); // async
      return value;
    }
  }

  has(key) {
    return this.#storage.getItem(key) != null;
  }

  set(key, value) {
    this.#storage.setItem(key, JSON.stringify(value));
  }

  delete(key) {
    this.#storage.removeItem(key);
  }

  constructor() {
    try {
      this.#storage = window.localStorage;
    } catch (e) {
      // localStorage is disabled for data URL documents which are used in testing.
      if (e.name != 'SecurityError') {
        this.reportError(`Failed to get localStorage`, e); // async
      }
      this.#storage = new InMemoryLocalStorage();
    }
  }

  async reportError(...args) {
    const logger = await import(`./logger.js`);
    return logger.error(...args);
  }

  #storage;
}

export const storage = new Storage();
